module.exports = __webpack_public_path__ + "static/img/gpt51.a5c42dfb.png";